export enum EntInterval {
	Lifetime = "lifetime",
	Minute = "minute",
	Hour = "hour",
	Day = "day",
	Week = "week",
	Month = "month",
	Quarter = "quarter",
	SemiAnnual = "semi_annual",
	Year = "year",
}
